import { useMargin, useClassNames } from '@magnetic/hooks';
import { IconContext, X } from '@magnetic/icons';
import React, { forwardRef } from 'react';
import './style.css.js';

const iconSizeMap = {
  sm: 12,
  md: 14,
  lg: 16
};
const compactIconSizeMap = {
  sm: 16,
  md: 18,
  lg: 20
};
const TagFrame = forwardRef(
  ({
    as,
    children,
    className,
    margin,
    onClose,
    prefix,
    size = "md",
    wrap,
    ...props
  }, ref) => {
    const marginClassNames = useMargin(margin);
    const classNames = useClassNames(
      "mds-rebuild-tag",
      `mds-rebuild-tag-size-${size}`,
      {
        "mds-rebuild-tag-wrap": wrap
      },
      marginClassNames,
      className
    );
    const Component = as != null ? as : "div";
    return /* @__PURE__ */ React.createElement(IconContext.Provider, {
      value: {
        weight: "bold",
        size: iconSizeMap[size],
        color: "var(--interact-icon-weak-default)"
      }
    }, /* @__PURE__ */ React.createElement(Component, {
      ...props,
      className: classNames,
      ref,
      type: Component === "button" ? "button" : void 0
    }, prefix && /* @__PURE__ */ React.createElement("span", {
      className: "mds-rebuild-tag-prefix"
    }, prefix), children && /* @__PURE__ */ React.createElement("span", {
      className: "mds-rebuild-tag-content"
    }, children), onClose && /* @__PURE__ */ React.createElement("button", {
      "aria-label": "tag-close",
      className: "mds-rebuild-tag-close mds-rebuild-tag-suffix",
      onClick: onClose,
      type: "button"
    }, /* @__PURE__ */ React.createElement(X, null))));
  }
);

export { TagFrame, compactIconSizeMap, iconSizeMap };
//# sourceMappingURL=index.js.map
